import React from 'react'
import Card from './Card'

interface InfoCardProps {
  title: string
  subtitle?: string
  icon?: React.ComponentType<{ className?: string; style?: React.CSSProperties }>
  children: React.ReactNode
  className?: string
  onClick?: () => void
  animation?: {
    initial?: any
    animate?: any
    transition?: any
    whileHover?: any
  }
  headerActions?: React.ReactNode
}

const InfoCard: React.FC<InfoCardProps> = ({
  title,
  subtitle,
  icon: Icon,
  children,
  className = '',
  onClick,
  animation = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.3 }
  },
  headerActions
}) => {
  return (
    <Card onClick={onClick} animation={animation} className={className}>
      <div className="p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-3">
            {Icon && (
              <div className="p-2 rounded-lg" style={{ backgroundColor: 'var(--bg-secondary)' }}>
                <Icon className="h-5 w-5" style={{ color: 'var(--text-primary)' }} />
              </div>
            )}
            <div>
              <h3 
                className="text-lg font-bold"
                style={{ color: 'var(--text-primary)' }}
              >
                {title}
              </h3>
              {subtitle && (
                <p 
                  className="text-sm"
                  style={{ color: 'var(--text-secondary)' }}
                >
                  {subtitle}
                </p>
              )}
            </div>
          </div>
          {headerActions && (
            <div className="flex items-center space-x-2">
              {headerActions}
            </div>
          )}
        </div>
        <div className="w-full">
          {children}
        </div>
      </div>
    </Card>
  )
}

export default InfoCard
